export default __webpack_public_path__ + "static/media/phase1-line.286e82b0.svg";